const microsoftSupportedTimeZones = [
  "Etc/GMT+12",
  "Etc/GMT+11",
  "Pacific/Pago_Pago",
  "Pacific/Niue",
  "Pacific/Midway",
  "US/Samoa",
  "Pacific/Apia",
  "US/Aleutian",
  "America/Atka",
  "America/Adak",
  "Pacific/Johnston",
  "Pacific/Rarotonga",
  "Pacific/Tahiti",
  "Etc/GMT+10",
  "US/Hawaii",
  "Pacific/Honolulu",
  "Pacific/Marquesas",
  "America/Nome",
  "US/Alaska",
  "America/Yakutat",
  "America/Sitka",
  "America/Juneau",
  "America/Anchorage",
  "Pacific/Gambier",
  "Etc/GMT+9",
  "America/Fort_Nelson",
  "America/Creston",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Whitehorse",
  "Canada/Yukon",
  "America/Tijuana",
  "America/Santa_Isabel",
  "Mexico/BajaNorte",
  "America/Ensenada",
  "Pacific/Pitcairn",
  "Etc/GMT+8",
  "America/Metlakatla",
  "Canada/Pacific",
  "PST8PDT",
  "America/Los_Angeles",
  "US/Pacific",
  "America/Vancouver",
  "America/Hermosillo",
  "US/Arizona",
  "Etc/GMT+7",
  "America/Phoenix",
  "America/Mazatlan",
  "Mexico/BajaSur",
  "America/Shiprock",
  "America/Ciudad_Juarez",
  "Canada/Mountain",
  "America/Inuvik",
  "US/Mountain",
  "MST7MDT",
  "America/Denver",
  "America/Edmonton",
  "America/Yellowknife",
  "America/Boise",
  "America/Cambridge_Bay",
  "America/Cancun",
  "America/Managua",
  "America/Belize",
  "Etc/GMT+6",
  "America/Costa_Rica",
  "America/Guatemala",
  "Pacific/Galapagos",
  "America/Tegucigalpa",
  "America/El_Salvador",
  "America/North_Dakota/New_Salem",
  "US/Indiana-Starke",
  "America/Indiana/Tell_City",
  "America/Matamoros",
  "America/Rainy_River",
  "America/Knox_IN",
  "America/Rankin_Inlet",
  "America/Chicago",
  "America/Ojinaga",
  "America/North_Dakota/Beulah",
  "America/Indiana/Knox",
  "America/Winnipeg",
  "America/Menominee",
  "America/Resolute",
  "CST6CDT",
  "America/North_Dakota/Center",
  "Canada/Central",
  "US/Central",
  "Pacific/Easter",
  "Chile/EasterIsland",
  "America/Monterrey",
  "America/Bahia_Banderas",
  "America/Mexico_City",
  "America/Merida",
  "America/Chihuahua",
  "Mexico/General",
  "America/Regina",
  "Canada/Saskatchewan",
  "America/Swift_Current",
  "America/Panama",
  "America/Guayaquil",
  "America/Coral_Harbour",
  "Brazil/Acre",
  "Jamaica",
  "Etc/GMT+5",
  "America/Rio_Branco",
  "America/Eirunepe",
  "America/Cayman",
  "America/Jamaica",
  "America/Bogota",
  "America/Lima",
  "America/Porto_Acre",
  "America/Atikokan",
  "America/Kentucky/Monticello",
  "America/Louisville",
  "America/Nassau",
  "America/Pangnirtung",
  "America/Indiana/Winamac",
  "America/Detroit",
  "America/New_York",
  "US/Michigan",
  "US/Eastern",
  "EST5EDT",
  "America/Thunder_Bay",
  "Canada/Eastern",
  "America/Toronto",
  "America/Kentucky/Louisville",
  "America/Nipigon",
  "America/Montreal",
  "America/Iqaluit",
  "America/Indiana/Vincennes",
  "America/Indiana/Petersburg",
  "America/Port-au-Prince",
  "Cuba",
  "America/Havana",
  "America/Indiana/Marengo",
  "America/Indiana/Vevay",
  "America/Indianapolis",
  "America/Fort_Wayne",
  "US/East-Indiana",
  "America/Indiana/Indianapolis",
  "America/Grand_Turk",
  "America/Caracas",
  "America/Punta_Arenas",
  "America/Asuncion",
  "Atlantic/Bermuda",
  "America/Moncton",
  "Canada/Atlantic",
  "America/Glace_Bay",
  "America/Thule",
  "America/Halifax",
  "America/Goose_Bay",
  "America/Campo_Grande",
  "America/Cuiaba",
  "America/Guadeloupe",
  "America/Port_of_Spain",
  "America/Guyana",
  "America/Aruba",
  "America/Barbados",
  "America/Manaus",
  "America/Lower_Princes",
  "America/St_Barthelemy",
  "America/Porto_Velho",
  "America/Santo_Domingo",
  "America/Kralendijk",
  "America/Boa_Vista",
  "America/Blanc-Sablon",
  "America/Puerto_Rico",
  "America/Curacao",
  "America/Dominica",
  "America/Grenada",
  "America/Virgin",
  "America/Montserrat",
  "America/St_Vincent",
  "Etc/GMT+4",
  "America/St_Kitts",
  "America/Antigua",
  "America/Anguilla",
  "America/Tortola",
  "America/Martinique",
  "Brazil/West",
  "America/St_Thomas",
  "America/Marigot",
  "America/La_Paz",
  "America/St_Lucia",
  "Chile/Continental",
  "America/Santiago",
  "Canada/Newfoundland",
  "America/St_Johns",
  "America/Araguaina",
  "Brazil/East",
  "America/Sao_Paulo",
  "America/Paramaribo",
  "Etc/GMT+3",
  "America/Santarem",
  "Atlantic/Stanley",
  "America/Recife",
  "America/Fortaleza",
  "America/Maceio",
  "America/Cayenne",
  "Antarctica/Palmer",
  "America/Belem",
  "Antarctica/Rothera",
  "America/Argentina/Buenos_Aires",
  "America/Mendoza",
  "America/Argentina/ComodRivadavia",
  "America/Rosario",
  "America/Jujuy",
  "America/Argentina/Tucuman",
  "America/Argentina/Cordoba",
  "America/Argentina/Catamarca",
  "America/Argentina/Mendoza",
  "America/Argentina/Rio_Gallegos",
  "America/Cordoba",
  "America/Argentina/San_Luis",
  "America/Argentina/Jujuy",
  "America/Catamarca",
  "America/Argentina/San_Juan",
  "America/Buenos_Aires",
  "America/Argentina/Ushuaia",
  "America/Argentina/Salta",
  "America/Argentina/La_Rioja",
  "America/Godthab",
  "America/Montevideo",
  "America/Miquelon",
  "America/Bahia",
  "America/Noronha",
  "Etc/GMT+2",
  "Atlantic/South_Georgia",
  "Brazil/DeNoronha",
  "Atlantic/Azores",
  "America/Scoresbysund",
  "Atlantic/Cape_Verde",
  "Etc/GMT+1",
  "GMT",
  "Etc/GMT",
  "Etc/UTC",
  "GMT+0",
  "Europe/London",
  "Europe/Guernsey",
  "Europe/Jersey",
  "Atlantic/Faroe",
  "Atlantic/Canary",
  "Europe/Lisbon",
  "Atlantic/Faeroe",
  "Europe/Dublin",
  "Europe/Isle_of_Man",
  "Europe/Belfast",
  "Atlantic/Madeira",
  "Eire",
  "Africa/Monrovia",
  "Africa/Accra",
  "Atlantic/St_Helena",
  "America/Danmarkshavn",
  "Africa/Dakar",
  "Africa/Conakry",
  "Africa/Nouakchott",
  "Atlantic/Reykjavik",
  "Africa/Timbuktu",
  "Africa/Lome",
  "Africa/Bamako",
  "Africa/Banjul",
  "Africa/Freetown",
  "Africa/Abidjan",
  "Africa/Ouagadougou",
  "Africa/Bissau",
  "Africa/Casablanca",
  "Africa/El_Aaiun",
  "Europe/Amsterdam",
  "Europe/Malta",
  "Europe/Luxembourg",
  "Europe/Rome",
  "Europe/Oslo",
  "Europe/Vaduz",
  "Europe/Gibraltar",
  "Europe/Monaco",
  "Atlantic/Jan_Mayen",
  "Europe/Berlin",
  "Europe/Stockholm",
  "Europe/Vatican",
  "Europe/Andorra",
  "Europe/Busingen",
  "Europe/Vienna",
  "Europe/San_Marino",
  "Europe/Zurich",
  "Arctic/Longyearbyen",
  "Europe/Budapest",
  "Europe/Tirane",
  "Europe/Podgorica",
  "Europe/Belgrade",
  "Europe/Ljubljana",
  "Europe/Prague",
  "Europe/Bratislava",
  "Europe/Madrid",
  "Africa/Ceuta",
  "Europe/Copenhagen",
  "Europe/Brussels",
  "Europe/Paris",
  "Europe/Zagreb",
  "Europe/Skopje",
  "Poland",
  "Europe/Sarajevo",
  "Europe/Warsaw",
  "Africa/Lagos",
  "Etc/GMT-1",
  "Africa/Algiers",
  "Africa/Douala",
  "Africa/Luanda",
  "Africa/Brazzaville",
  "Africa/Bangui",
  "Africa/Malabo",
  "Africa/Kinshasa",
  "Africa/Niamey",
  "Africa/Porto-Novo",
  "Africa/Libreville",
  "Africa/Tunis",
  "Africa/Ndjamena",
  "Africa/Tripoli",
  "Africa/Windhoek",
  "Asia/Nicosia",
  "Europe/Athens",
  "Asia/Famagusta",
  "Europe/Bucharest",
  "Asia/Beirut",
  "Egypt",
  "Africa/Cairo",
  "Europe/Chisinau",
  "Asia/Damascus",
  "Asia/Gaza",
  "Asia/Hebron",
  "Africa/Kigali",
  "Africa/Lubumbashi",
  "Africa/Gaborone",
  "Africa/Bujumbura",
  "Africa/Maputo",
  "Africa/Mbabane",
  "Africa/Harare",
  "Africa/Blantyre",
  "Africa/Lusaka",
  "Africa/Johannesburg",
  "Africa/Maseru",
  "Etc/GMT-2",
  "Europe/Kiev",
  "Europe/Tallinn",
  "Europe/Sofia",
  "Europe/Mariehamn",
  "Europe/Uzhgorod",
  "Europe/Vilnius",
  "Europe/Riga",
  "Europe/Kyiv",
  "Europe/Helsinki",
  "Europe/Zaporozhye",
  "Israel",
  "Asia/Jerusalem",
  "Asia/Tel_Aviv",
  "Africa/Juba",
  "Europe/Kaliningrad",
  "Africa/Khartoum",
  "Asia/Amman",
  "Turkey",
  "Europe/Istanbul",
  "Asia/Istanbul",
  "Europe/Minsk",
  "Asia/Baghdad",
  "Asia/Aden",
  "Asia/Kuwait",
  "Asia/Riyadh",
  "Asia/Bahrain",
  "Asia/Qatar",
  "Europe/Simferopol",
  "Europe/Kirov",
  "Europe/Moscow",
  "Indian/Mayotte",
  "Etc/GMT-3",
  "Africa/Djibouti",
  "Africa/Kampala",
  "Africa/Asmera",
  "Indian/Comoro",
  "Africa/Addis_Ababa",
  "Antarctica/Syowa",
  "Africa/Dar_es_Salaam",
  "Africa/Nairobi",
  "Africa/Asmara",
  "Indian/Antananarivo",
  "Africa/Mogadishu",
  "Europe/Volgograd",
  "Europe/Ulyanovsk",
  "Europe/Astrakhan",
  "Europe/Samara",
  "Europe/Saratov",
  "Asia/Tehran",
  "Iran",
  "Etc/GMT-4",
  "Asia/Muscat",
  "Asia/Dubai",
  "Asia/Baku",
  "Indian/Mauritius",
  "Indian/Reunion",
  "Indian/Mahe",
  "Asia/Tbilisi",
  "Asia/Yerevan",
  "Asia/Kabul",
  "Asia/Ashkhabad",
  "Indian/Maldives",
  "Asia/Oral",
  "Asia/Tashkent",
  "Antarctica/Mawson",
  "Asia/Atyrau",
  "Asia/Aqtau",
  "Etc/GMT-5",
  "Asia/Aqtobe",
  "Asia/Samarkand",
  "Asia/Ashgabat",
  "Asia/Dushanbe",
  "Indian/Kerguelen",
  "Asia/Qyzylorda",
  "Asia/Qostanay",
  "Asia/Almaty",
  "Asia/Yekaterinburg",
  "Asia/Karachi",
  "Asia/Kolkata",
  "Asia/Calcutta",
  "Asia/Colombo",
  "Asia/Kathmandu",
  "Asia/Katmandu",
  "Antarctica/Vostok",
  "Etc/GMT-6",
  "Indian/Chagos",
  "Asia/Bishkek",
  "Asia/Thimphu",
  "Asia/Dhaka",
  "Asia/Dacca",
  "Asia/Thimbu",
  "Asia/Omsk",
  "Asia/Barnaul",
  "Asia/Novosibirsk",
  "Asia/Tomsk",
  "Asia/Yangon",
  "Indian/Cocos",
  "Asia/Rangoon",
  "Asia/Phnom_Penh",
  "Indian/Christmas",
  "Asia/Jakarta",
  "Asia/Pontianak",
  "Asia/Ho_Chi_Minh",
  "Asia/Saigon",
  "Asia/Bangkok",
  "Asia/Vientiane",
  "Etc/GMT-7",
  "Antarctica/Davis",
  "Asia/Hovd",
  "Asia/Novokuznetsk",
  "Asia/Krasnoyarsk",
  "Asia/Kashgar",
  "Asia/Harbin",
  "Asia/Chungking",
  "Hongkong",
  "Asia/Chongqing",
  "Asia/Urumqi",
  "Asia/Macao",
  "Asia/Shanghai",
  "Asia/Hong_Kong",
  "Asia/Macau",
  "Asia/Irkutsk",
  "Asia/Kuala_Lumpur",
  "Asia/Manila",
  "Asia/Kuching",
  "Asia/Ujung_Pandang",
  "Asia/Brunei",
  "Etc/GMT-8",
  "Asia/Singapore",
  "Asia/Makassar",
  "Antarctica/Casey",
  "Australia/West",
  "Australia/Perth",
  "Asia/Taipei",
  "Asia/Ulan_Bator",
  "Asia/Ulaanbaatar",
  "Asia/Choibalsan",
  "Asia/Chita",
  "Asia/Pyongyang",
  "Australia/Eucla",
  "Pacific/Palau",
  "Asia/Dili",
  "Asia/Jayapura",
  "Etc/GMT-9",
  "Asia/Tokyo",
  "Asia/Seoul",
  "Asia/Khandyga",
  "Asia/Yakutsk",
  "Australia/South",
  "Australia/Broken_Hill",
  "Australia/Adelaide",
  "Australia/Yancowinna",
  "Australia/Darwin",
  "Australia/North",
  "Australia/Queensland",
  "Australia/Brisbane",
  "Australia/Lindeman",
  "Australia/Victoria",
  "Australia/NSW",
  "Australia/Sydney",
  "Australia/Canberra",
  "Australia/Melbourne",
  "Australia/ACT",
  "Pacific/Port_Moresby",
  "Pacific/Guam",
  "Pacific/Saipan",
  "Etc/GMT-10",
  "Pacific/Chuuk",
  "Antarctica/DumontDUrville",
  "Pacific/Truk",
  "Australia/Tasmania",
  "Australia/Currie",
  "Australia/Hobart",
  "Antarctica/Macquarie",
  "Asia/Vladivostok",
  "Asia/Ust-Nera",
  "Pacific/Bougainville",
  "Asia/Magadan",
  "Asia/Sakhalin",
  "Australia/Lord_Howe",
  "Australia/LHI",
  "Asia/Srednekolymsk",
  "Pacific/Norfolk",
  "Pacific/Pohnpei",
  "Pacific/Kosrae",
  "Pacific/Guadalcanal",
  "Pacific/Efate",
  "Pacific/Ponape",
  "Pacific/Noumea",
  "Etc/GMT-11",
  "Asia/Kamchatka",
  "Asia/Anadyr",
  "Pacific/Auckland",
  "Antarctica/South_Pole",
  "Antarctica/McMurdo",
  "Pacific/Wake",
  "Pacific/Majuro",
  "Pacific/Funafuti",
  "Pacific/Kwajalein",
  "Pacific/Nauru",
  "Pacific/Tarawa",
  "Pacific/Wallis",
  "Etc/GMT-12",
  "Pacific/Fiji",
  "Pacific/Chatham",
  "Pacific/Fakaofo",
  "Etc/GMT-13",
  "Pacific/Enderbury",
  "Pacific/Tongatapu",
  "Pacific/Kiritimati",
  "Etc/GMT-14"
];
export {
  microsoftSupportedTimeZones
};
//# sourceMappingURL=date-microsoft.mjs.map
